import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

import {API} from '../../settings.js';
import {ajaxPost} from '../../helpers/apiData.js';

class LikeBtn extends React.Component {
  static propTypes = {
    catSlug: PropTypes.string,
    itemSlug: PropTypes.string,
    lang: PropTypes.string,
    likes: PropTypes.number,
    restSlug: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.toggle = 'inactive';

    this.state = {
      // data object needed by ajaxPost
      data: {like: 0}
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentWillReceiveProps() {
    this.setState({data: {like: this.props.likes}});
  }

  shouldComponentUpdate(nextState) {
    return (this.state.data.like !== nextState.like);
  }

  handleClick() {
    let like;

    if (this.toggle === 'inactive') {
      this.toggle = 'active';
      like = true;

    } else if (this.toggle === 'active') {
      this.toggle = 'inactive';
      like = false;
    }
    // makes the post and sets data to re-render (setState)
    ajaxPost(API + this.props.lang + '/api/' + this.props.restSlug + '/items/' + this.props.catSlug.split("-").pop() +
      '/' + this.props.itemSlug.split("-").pop() + '/like/', {like: like}, this);
  }

  render() {
    return (
      <div className="recommend-box">
        <div className="recommend-text">
          {this.props.itemType === 'food' ?
            <div>
              <FormattedMessage id="recommend_title">
                {(message) => <h4>{message}</h4>}
              </FormattedMessage>
              <FormattedMessage id="recommend-total" values={{total: String(this.state.data.like)}}/>
            </div> :
            <div>
              <FormattedMessage id="recommend_title_drink">
                {(message) => <h4>{message}</h4>}
              </FormattedMessage>
              <FormattedMessage id="recommend-total_drink" values={{total: String(this.state.data.like)}}/>
            </div>
          }

        </div>
        <button className={'likes ' + this.toggle} onClick={this.handleClick}/>
      </div>
    );
  }
}

export default LikeBtn;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/LikeBtn.js
 **/